var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A2A2A0",
    d: "M6 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm0 2.483L4.978 4.597l-2.288.336 1.655 1.642-.388 2.322L6 7.804l2.043 1.093-.388-2.322L9.31 4.933l-2.288-.336L6 2.483z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificationIcon);
export default __webpack_public_path__ + "static/media/certification-icon.f5884ed4e23a4c34243f8c417794b3ed.svg";
export { ForwardRef as ReactComponent };